import request from "./http";
const mainApiData = {
  signIn(data) {
    return request({
      url: `/sub/signIn/` + data,
      method: "get",
    });
  },
  allSignIn() {
    return request({
      url: `/sub/allSignIn`,

      method: "get",
    });
  },
  getAddrList() {
    return request({
      url: `/assets/getAddrList`,

      method: "post",
    });
  },
  getHomeInfo() {
    return request({
      url: `/user/getHomeInfo`,
      // params,
      method: "post",
    });
  },
  // 用户注册
  saveUser(data) {
    return request({
      url: `/user/saveUser`,
      params: data,
      method: "post",
    });
  },
  // 登录
  login(data) {
    return request({
      url: `/user/login`,
      params: data,
      method: "post",
    });
  },
  // 修改登录密码
  UpPassword(data) {
    return request({
      url: `/user/modify/password`,
      params: data,
      method: "get",
    });
  },
  // 找回登录密码/重置登录密码
  FindPassword(data) {
    return request({
      url: `/user/find/password`,
      params: data,
      method: "get",
    });
  },
  // 修改交易密码
  JyPassword(data) {
    return request({
      url: `/user/modify/JyPassword`,
      params: data,
      method: "get",
    });
  },
  // 重置交易密码
  FindJyPassword(data) {
    return request({
      url: `/user/find/JyPassword`,
      params: data,
      method: "get",
    });
  },
  // 查询所有币种
  getAllCoin(data) {
    return request({
      url: `/assets/getAllCoin`,
      method: "get",
    });
  },
  //  取消委托
  Withdrawal(data) {
    return request({
      url: `/exchange/cancel`,
      params: data,
      method: "post",
    });
  },
  // 下单
  addOrder(data) {
    return request({
      url: `/exchange/addOrder`,
      params: data,
      method: "post",
    });
  },
  //查询历史委托
  ExchangeHistory(data) {
    return request({
      url: `/exchange/history`,
      params: data,
      method: "post",
    });
  },
  // 查询用户指定币种的资产信息
  getAssetsByCoinName(data) {
    return request({
      url: `/assets/getAssetsByCoinName`,
      params: data,
      method: "get",
    });
  },
  // 查询用户所有币种的资产信息
  getUserAllAssets(data) {
    return request({
      url: `/assets/getUserAllAssets`,
      params: data,
      method: "get",
    });
  },
  // 闪兑
  flashExchange(data) {
    return request({
      url: `/assets/flashExchange`,
      params: data,
      method: "get",
    });
  },
  // 闪兑历史记录
  flashLog(data) {
    return request({
      url: `/assets/flashLog`,
      params: data,
      method: "post",
    });
  },
  // 查询最新币种行情价格
  lastPrice(data) {
    return request({
      url: `/assets/lastPrice`,
      params: data,
      method: "get",
    });
  },
  // 确认转账
  ackTransfer(data) {
    return request({
      url: `/assets/ackTransfer`,
      params: data,
      method: "get",
    });
  },
  // 查询转账记录
  transferLog(data) {
    return request({
      url: `/assets/transferLog`,
      params: data,
      method: "post",
    });
  },
  // 确认认购
  confirmSubScribe(data) {
    return request({
      url: `/sub/confirmSubScribe`,
      params: data,
      method: "post",
    });
  },
  // 查询认购订单
  getPageSubOrder(data) {
    return request({
      url: `/sub/getPageSubOrder`,
      params: data,
      method: "post",
    });
  },
  // 查询当前认购订单的释放明细 s
  Detailed(data) {
    return request({
      url: `/sub/Detailed`,
      params: data,
      method: "post",
    });
  },
  // 查询币种财务记录
  financeLog(data) {
    return request({
      url: `/assets/financeLog`,
      params: data,
      method: "post",
    });
  },
  // 我的团队
  myTeam(data) {
    return request({
      url: `/user/myTeam`,
      params: data,
      method: "get",
    });
  },
  // 我的收益
  myIncome(data) {
    return request({
      url: `/user/myIncome`,
      params: data,
      method: "get",
    });
  },
  // 我的收益-明细
  myIncomeDetailed(data) {
    return request({
      url: `/user/myIncomeDetailed`,
      params: data,
      method: "get",
    });
  },
  // 查询认购统计信息
  statis(data) {
    return request({
      url: `/sub/statis`,
      params: data,
      method: "post",
    });
  },
  // 查询最新币种行情价格
  lastPrice(data) {
    return request({
      url: `/assets/lastPrice`,
      params: data,
      method: "get",
    });
  },
  // 总资产折合
  getUserEquivalent(data) {
    return request({
      url: `/assets/getUserEquivalent`,
      params: data,
      method: "get",
    });
  },
  // 用户等级
  getUserGrade() {
    return request({
      url: `/user/getUserGrade`,

      method: "get",
    });
  },
  // 用户提现
  userWithdraw(data) {
    return request({
      url: `/assets/userWithdraw`,
      params: data,
      method: "post",
    });
  },
  // 提币记录
  withdrawLog(data) {
    return request({
      url: `/assets/withdrawLog`,
      params: data,
      method: "post",
    });
  },
  //充币记录
  rechargeLog(data) {
    return request({
      url: `/assets/rechargeLog`,
      params: data,
      method: "post",
    });
  },
  //用户充值
  userRecharge(data) {
    return request({
      url: `/assets/userRecharge`,
      params: data,
      method: "post",
    });
  },
  // 查询转账信息
  getTransferInfo(data) {
    return request({
      url: `/assets/getTransferInfo`,
      params: data,
      method: "get",
    });
  },
  //查询最新公告
  getLastArticles(data) {
    return request({
      url: `/articles/getLastArticles`,
      params: data,
      method: "get",
    });
  },
  // 分页查询公告
  getALLArticles(data) {
    return request({
      url: `/articles/getALLArticles`,
      params: data,
      method: "get",
    });
  },
  // 查询配置信息
  getPublicConfig(data) {
    return request({
      url: `/user/getPublicConfig`,
      params: data,
      method: "post",
    });
  },
  // 查询指定币种费率
  getCoinByName(data) {
    return request({
      url: `/assets/getCoinByName`,
      params: data,
      method: "get",
    });
  },
  // 用户登录-通过地址
  loginAddr(data) {
    return request({
      url: `/user/loginAddr`,
      params: data,
      method: "post",
    });
  },
  //绑定地址
  bindUserAddr(data) {
    return request({
      url: `/user/bindUserAddr`,
      params: data,
      method: "post",
    });
  },
  // 判断用户是否绑定地址 true-已经绑定了地址 false-没有绑定地址
  judgeUserAddr(data) {
    return request({
      url: `/user/judgeUserAddr`,
      params: data,
      method: "post",
    });
  },
  // u查询用户地址
  getUserAddr(data) {
    return request({
      url: `/user/getUserAddr`,
      params: data,
      method: "post",
    });
  },
};
export { mainApiData };
